// extracted by mini-css-extract-plugin
module.exports = {"goBackLink":"GoBack_goBackLink__EJSnp"};